import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getSalesforceAccessToken } from "@redux/actions/utility-actions";
import { loginReq } from "@config/authConfig";

/**
 * Hook to handle SSO login
 * @returns {Object} SSO login state and handlers
 */
export const useSSOLogin = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoized SSO login handler
  const handleSSOLogin = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await instance.loginPopup(loginReq);
      const email = response.account.username;
      
      console.log("🔐 SSO login success, fetching Salesforce token for:", email);
      
      await dispatch(getSalesforceAccessToken(email));
      console.log("✅ Salesforce token fetched successfully");
      console.log("🚀 Token refresh service will handle automatic refreshes");
      
    } catch (err) {
      console.error("❌ SSO/Authentication failed:", err);
      setError("Failed to authenticate. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [instance, dispatch]);

  return { handleSSOLogin, loading, error, setError };
};
